package com.siriusxm.cmc.utils

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
public data class IdToken(
    val sub: String,

    @SerialName("cognito:groups")
    val cognitoGroups: List<String>,

    val email: String? = null
)